module.exports = __webpack_public_path__ + "static/img/5.709ac55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/5.png
// module id = L+DB
// module chunks = 0